import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { LightModal } from '@repo/ui/components/Modal/LightModal';
import { TERMS_OF_SERVICE_TEXT } from '../components/login/policyConstants';

export const Route = createFileRoute('/terms-of-service')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <LightModal
        isOpen={true}
        title="Terms of Service for Cloud App"
        onClose={() => navigate({ to: '/login' })}
        className="max-w-4xl"
      >
        <div className="prose prose-sm max-w-none">{TERMS_OF_SERVICE_TEXT}</div>
      </LightModal>
    </div>
  );
}
